"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleSearchConsoleUrlInspection = exports.googleSearchConsoleUrlInspectionResultSchema = exports.googleSearchConsoleUrlInspectionArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.googleSearchConsoleUrlInspectionArgsSchema = zod_1.z.object({
    url: zod_1.z
        .string()
        .describe('The URL to inspect. Must be a full URL including protocol (e.g., https://example.com/page)'),
    siteUrl: zod_1.z
        .string()
        .describe('The Search Console property URL. Can be either:\n' +
        '• Domain property: sc-domain:example.com\n' +
        '• URL prefix property: https://example.com or https://www.example.com'),
    emitMode: common_1.emitModeSchema.default('single').describe('The mode to emit the data in.'),
});
exports.googleSearchConsoleUrlInspectionResultSchema = zod_1.z.object({
    indexStatus: zod_1.z
        .enum(['INDEXED', 'NOT_INDEXED', 'UNKNOWN'])
        .describe('The indexing status of the URL'),
    coverageState: zod_1.z.string().optional().describe('The coverage state of the URL in Google Search'),
    lastCrawlTime: zod_1.z
        .string()
        .optional()
        .describe('ISO timestamp of when Google last crawled this URL'),
    indexingState: zod_1.z.string().optional().describe('The current indexing state of the URL'),
    issues: zod_1.z
        .array(zod_1.z.object({
        severity: zod_1.z.string().describe('Severity of the issue (e.g., ERROR, WARNING)'),
        issueType: zod_1.z.string().describe('Type of issue found'),
        message: zod_1.z.string().describe('Detailed message about the issue'),
    }))
        .optional()
        .describe('List of indexing issues found for the URL'),
    mobileUsability: zod_1.z
        .object({
        verdict: zod_1.z.string().describe('Mobile usability verdict (PASS, FAIL, etc.)'),
        issues: zod_1.z
            .array(zod_1.z.object({
            severity: zod_1.z.string().describe('Severity of the mobile usability issue'),
            rule: zod_1.z.string().describe('The mobile usability rule that failed'),
        }))
            .optional()
            .describe('List of mobile usability issues'),
    })
        .optional()
        .describe('Mobile usability test results'),
    richResults: zod_1.z
        .object({
        verdict: zod_1.z.string().describe('Rich results verdict (PASS, FAIL, etc.)'),
        detectedItems: zod_1.z
            .array(zod_1.z.object({
            richResultType: zod_1.z.string().describe('Type of rich result detected'),
            items: zod_1.z
                .array(zod_1.z.object({
                name: zod_1.z.string().describe('Name of the rich result item'),
                value: zod_1.z.string().optional().describe('Value of the rich result item'),
            }))
                .optional()
                .describe('Items in the rich result'),
        }))
            .optional()
            .describe('Rich results detected on the page'),
    })
        .optional()
        .describe('Rich results test results'),
});
exports.googleSearchConsoleUrlInspection = (0, common_1.createEmitModeToolMetadata)({
    id: 'googleSearchConsoleUrlInspection',
    displayName: 'Google Search Console URL Inspection',
    displayDescription: 'Inspect a URL in Google Search Console to check indexing status, identify issues, and get mobile usability and rich results information. Essential for SEO troubleshooting and optimization.',
    category: 'seo',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'search',
    argsSchema: exports.googleSearchConsoleUrlInspectionArgsSchema,
}, exports.googleSearchConsoleUrlInspectionResultSchema);
